"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.normalCase = exports.kebabCase = exports.keyToken = exports.onOffBoolean = exports.media = exports.truncateNumber = exports.withUniqueProp = exports.prop = exports.cond = exports.omitProps = void 0;

var _recompose = require("recompose");

var R = _interopRequireWildcard(require("ramda"));

var _v = _interopRequireDefault(require("uuid/v4"));

var _core = require("@emotion/core");

var _defaults = _interopRequireDefault(require("../theme-provider/defaults"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

var omitProps = R.compose(_recompose.mapProps, R.omit);
exports.omitProps = omitProps;

var funcOrString = function funcOrString(f, props) {
  return typeof f === 'function' ? f(props) : f;
};

var cond = function cond(conditions) {
  return function (props) {
    return conditions.filter(function (condition) {
      return Array.isArray(condition) ? condition[0](props) : true;
    }).map(function (condition) {
      return condition[1] ? funcOrString(condition[1], props) : funcOrString(condition, props);
    });
  };
};

exports.cond = cond;

var prop = function prop(_prop, conditions) {
  return function (props) {
    return typeof conditions === 'string' || typeof conditions === 'function' ? props[_prop] && funcOrString(conditions, props) : funcOrString(conditions[props[_prop]], props);
  };
};

exports.prop = prop;

var withUniqueProp = function withUniqueProp(propName) {
  return (0, _recompose.compose)((0, _recompose.withState)(propName, 'setProp', function (props) {
    return props[propName] || null;
  }), (0, _recompose.lifecycle)({
    componentWillMount: function componentWillMount() {
      if (R.isNil(this.props[propName])) {
        this.props.setProp((0, _v.default)());
      }
    }
  }), omitProps(['setProp']));
};

exports.withUniqueProp = withUniqueProp;

var truncateNumber = function truncateNumber(number) {
  return number > 9 ? '9+' : number;
};

exports.truncateNumber = truncateNumber;
var sizes = _defaults.default.sizes;
var media = Object.keys(sizes).reduce(function (acc, label) {
  acc[label] = function () {
    return (
      /*#__PURE__*/
      (0, _core.css)("@media (min-width:", sizes[label] / 16, "em){",
      /*#__PURE__*/
      _core.css.apply(void 0, arguments), ";}" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"))
    );
  };

  return acc;
}, {});
exports.media = media;

var onOffBoolean = function onOffBoolean(v) {
  if (typeof v === 'boolean') {
    return v ? 'on' : 'off';
  }

  return v;
};

exports.onOffBoolean = onOffBoolean;

var keyToken = function keyToken() {
  return String(Math.random()).split('.')[1].slice(0, 10);
};

exports.keyToken = keyToken;
var kebabCase = R.pipe(R.when(R.complement(R.is(String)), R.toString), R.replace(/ /g, '-'));
exports.kebabCase = kebabCase;
var normalCase = R.replace(/-|_/g, ' ');
exports.normalCase = normalCase;